import {delay, put, select, takeEvery} from "../../../../shared/SagaService";
import actions from "../../actions";
import AppActions from "../../../App/actions";
import {message} from "antd";
import {getInitData} from "../../../Transaction/initTransaction/helper/getInitData";
import {parseTransactionForInstruction} from "./parseTransactionForInstruction";
import TransactionActions from "../../../Transaction/actions";
import EditableActions from '../../../EditableTable/actions';
import { TableName } from '../../../EditableTable/options';

function* onTransactionTypeChange(action) {
    const { transactionType } = action;

    const instruction = yield select(state => state.Instruction.instruction);

    let transaction;
    console.log('aaa onTransactionTypeChange 1', {
        transactionType,
        instruction,
    });
    if (instruction.data) {
        transaction = instruction.data;
    }
    else {
        transaction = yield getInitData(transactionType);
        transaction = parseTransactionForInstruction(transactionType, transaction);
        console.log('aaa onTransactionTypeChange 2', {
            transactionType,
            instruction,
            transaction,
        });
        if (transaction.deposit_items) {
            yield put(EditableActions.withName(TableName.payment_deposit_item)
                .setItems(transaction.deposit_items));
        }

        if (transaction.term_items) {
            yield put(EditableActions.withName(TableName.payment_term)
                .setItems(transaction.term_items));
        }
    }

    // Update Store
    yield put(
        TransactionActions.transactionInitSuccess(transaction),
    );
}

function* cleanupTransaction() {
    yield EditableActions.resetTable(TableName.form_item);
    yield EditableActions.resetTable(TableName.bank_item);
    yield EditableActions.resetTable(TableName.payment_deposit_item);
    yield EditableActions.resetTable(TableName.payment_term);
    yield EditableActions.resetTable(TableName.journal_item);
    yield put(TransactionActions.transactionResetState());
}

export function* onTransactionTypeChangeListener() {
    yield takeEvery(actions.CHANGE_TRANSACTION_TYPE, function* (action) {
        try {
            yield put({type: AppActions.APP_START_PULLING});
            yield cleanupTransaction();
            yield delay(1); // required to block until cleanup is done, so that terms can be populated correctly
            yield onTransactionTypeChange(action);
        }
        catch (error) {
            yield put({
                type: actions.INIT_INSTRUCTION_ERROR,
                error,
            });
            yield message.error(error.message);
        }
        finally {
            yield put({type: AppActions.APP_STOP_PULLING});
        }
    });
}
